export default __webpack_public_path__ + "static/media/footer-text-logo.612f8543.svg";